import "./polyfills";

import * as Pages from "./pages";
// import * as Components from "./components";
import "./vendors";
import GameLogic from "./core/game-logic";

/* Entry script */
// window.screenCalculationFunc = null;

// console.log('masuk sini');

//Pages object
Object.keys(Pages).forEach((key) => new Pages[key]());

//Components object
// Object.keys(Components).forEach((key) => Components[key]());

//Start game init
GameLogic.init();